export default {
    TYPES: [
        [1, 'Stock (IBC)'],
        [2, 'California (CBC)'],
        [3, 'Florida (NOA)'],
        [4, 'Florida (FBC)'],
    ]
}